<template>
	<div>
		<div class='section__header'>
			<div class='section__title'>Выдел {{ currentLpo.section + (currentLpo.section_lp ? ' (' + currentLpo.section_lp + ')' : '') }}</div>

			<div class='section__buttons'>
				<p-button label='Загрузить фото' icon='fa fa-plus' @click='openModalPhoto' class='p-button-sm p-mr-2' :disabled='!actLpoIsDraft'/>
				<p-button label='Загрузить треки' icon='fa fa-plus' @click='openModalTrack' class='p-button-sm p-mr-2' :disabled='!actLpoIsDraft'/>
				<p-button label='Загрузить ТО' icon='fa fa-plus' @click='openModalTax' class='p-button-sm' :disabled='!actLpoIsDraft'/>
			</div>
		</div>

		<div class='section__content'>

			<template v-if='!photoList.length && !trackList.length && !taxFile'>
				<div class='empty-message'>Материалы для данного выдела не загружены</div>
			</template>

			<template v-else>
				<ActUploadsPhoto
					v-if='photoList.length'
					:current-lpo='currentLpo'
					:photo-list='photoList'
					@removed='onPhotoRemoved'
					class='section__file-block'
				/>
				<ActUploadsTrack
					v-if='trackList.length'
					:current-lpo='currentLpo'
					:track-list='trackList'
					@removed='onTrackRemoved'
					class='section__file-block'
				/>
				<ActUploadsTax
					v-if='taxFile'
					:current-lpo='currentLpo'
					:tax-file='taxFile'
					@removed='onTaxRemoved'
					class='section__file-block'
				/>
			</template>
		</div>

		<ActUploadsModalPhoto v-model='modalPhotoOpen' :current-lpo='currentLpo' @uploaded='onPhotoUploaded'/>
		<ActUploadsModalTrack v-model='modalTrackOpen' :current-lpo='currentLpo' @uploaded='onTrackUploaded'/>
		<ActUploadsModalTax v-model='modalTaxOpen' :current-lpo='currentLpo' @uploaded='onTaxUploaded'/>

	</div>
</template>

<script>
	const ROOT_API = process.env.VUE_APP_ROOT_API;
	const PHOTO_GET_PATH_LIST = ROOT_API + 'load_file/photo_get_path_list.php';
	const PHOTO_GET_IMAGE = ROOT_API + 'load_file/photo_get_image.php';
	const TRACK_GET_LIST = ROOT_API + 'load_file/track_get_list.php';
	const TAX_GET_FILE = ROOT_API + 'load_file/tax_get_file.php';

	import ActUploadsPhoto from './ActUploads__photo';
	import ActUploadsTrack from './ActUploads__track';
	import ActUploadsTax from './ActUploads__tax';

	import ActUploadsModalPhoto from './ActUploads__modalPhoto';
	import ActUploadsModalTrack from './ActUploads__modalTrack';
	import ActUploadsModalTax from './ActUploads__modalTax';

	export default {
		name: 'ActUploadsSection',

		components: {
			ActUploadsPhoto,
			ActUploadsTrack,
			ActUploadsTax,

			ActUploadsModalPhoto,
			ActUploadsModalTrack,
			ActUploadsModalTax
		},

		data: () => ({
			photoList: [],
			trackList: [],
			taxFile: null,

			modalPhotoOpen: false,
			modalTrackOpen: false,
			modalTaxOpen: false
		}),

		computed: {
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },
		},

		props: {
			currentLpo: Object
		},

		methods: {
			/* TAX */
			getTaxFile() {
				this.taxFile = null;

				const form = new FormData();
				form.append('lpo_id', this.currentLpo.lpo_id);

				return fetch(TAX_GET_FILE, {
					credentials: 'include',
					method: 'post',
					body: form
				})
				.then(res => res.json())
				.then(res => {
					this.taxFile = res;
				});
			},

			openModalTax() {
				this.modalTaxOpen = true;
			},

			onTaxUploaded() {
				this.modalTaxOpen = false;
				this.getTaxFile();
			},

			onTaxRemoved() {
				this.getTaxFile();
			},


			/* TRACK */
			getTrackList() {
				this.trackList = [];

				const form = new FormData();
				form.append('lpo_id', this.currentLpo.lpo_id);

				return fetch(TRACK_GET_LIST, {
					credentials: 'include',
					method: 'post',
					body: form
				})
				.then(res => res.json())
				.then(res => {
					// this.trackList = res;

					this.trackList = res.map(item => ({
						name: item.name,
						path: item.path,
						checked: false
					}));

				});
			},

			onTrackRemoved() {
				this.getTrackList();
			},

			openModalTrack() {
				this.modalTrackOpen = true;
			},

			onTrackUploaded() {
				this.modalTrackOpen = false;
				this.getTrackList();
			},

			/* PHOTO */
			onPhotoRemoved() {
				this.getPhotoList();
			},

			openModalPhoto() {
				this.modalPhotoOpen = true;
			},

			onPhotoUploaded() {
				this.modalPhotoOpen = false;
				this.getPhotoList();
			},


			async getPhotoList() {
				this.photoList = [];

				// this.$emit('download-begin');

				const photoInfoList = await this.getPhotoInfoList();

				for (let file of photoInfoList) {
					this.getPhotoFile(file);
				}
			},

			getPhotoInfoList() {

				const form = new FormData();
				form.append('lpo_id', this.currentLpo.lpo_id);

				return fetch(PHOTO_GET_PATH_LIST, {
					credentials: 'include',
					method: 'post',
					body: form
				})
				.then(res => res.json());
			},

			getPhotoFile(file) {
				const form = new FormData();
				form.append('path', file.path);

				fetch(PHOTO_GET_IMAGE, {
					credentials: 'include',
					method: 'post',
					body: form
				})
				.then(res => res.blob())
				.then(res => {
					const url = URL.createObjectURL(res);
					const image = new Image;
					image.src = url;

					image.onload = () => {
						const temp = {
							name: file.name,
							path: file.path,
							url: url,
							checked: false,
							width: image.width,
							height: image.height
						};

						this.photoList.push(temp);
					}	
	
				});
			}
		},

		created() {
			this.getPhotoList();
			this.getTrackList();
			this.getTaxFile();
		}
	};
</script>

<style scoped>
	.empty-message {
		margin-top: 1rem;
		font-style: italic;
	}

	.section__title {
		font-size: 1.1rem;
		margin-bottom: 0.5rem;
		font-weight: bold;
		color: #6c757d;
		font-style: italic;
		border-bottom: 1px solid #6c757d;
		padding-bottom: 0.5rem;
	}

	.section__file-block {
		margin-bottom: 3rem;
	}

	.section__content {
		padding: 0 2rem;
	}
</style>